import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarClock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCalendarClock"><Path d="M16 20.5C19.5899 20.5 22.5 17.5898 22.5 14C22.5 10.4101 19.5899 7.5 16 7.5C12.4101 7.5 9.5 10.4101 9.5 14C9.5 17.5898 12.4101 20.5 16 20.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M16 11.66V14L18.08 16.08" stroke="currentColor" strokeLinecap="square"/><Path d="M2.15024 9.63484L3.73399 18.6168L10.1409 17.487M2.15024 9.63484L1.47656 5.81425L15.2639 3.38318L15.9375 7.20377L2.15024 9.63484Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCalendarClock;
